import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { generarReporteEnExcel} from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';

class FormVen15  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            fechaDesde: null,
            fechaHasta: null            
        };
        
        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.generarReporteVentas = this.generarReporteVentas.bind(this);
    }
    
    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0415')         
        .then(() => {
            let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
            let fechaDesde = fechaHasta.subtract(31, 'days');
            this.setState({ fechaDesde,
                            fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY")                            
                        });
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0415');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    generarReporteVentas(){        
        try {

            let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
            if (!validarFechaMomentEnFormatoString(fechaDesde)){
                alert('La fecha Desde es inválida.');
                return;
            }
            
            let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
            if (!validarFechaMomentEnFormatoString(fechaHasta)){
                alert('La fecha Hasta es inválida.');
                return;
            }

            if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                return;
            }

            let urlReportWithParams = `&rpt=55&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
            urlReportWithParams += `&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;
            
            generarReporteEnExcel(urlReportWithParams);
        } catch (error) {
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    }

    limpiar(){
        let fechaHasta = moment(this.props.fechaProceso, "DD/MM/YYYY");
        let fechaDesde = fechaHasta.subtract(31, 'days');
        this.setState({ fechaDesde: fechaDesde,
                        fechaHasta: moment(this.props.fechaProceso, "DD/MM/YYYY")
                    });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
            <HeaderForm>
                <TituloForm>Ventas por Factura/Nota de Venta</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-1' margen_arriba={20}>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1' margen_arriba={20}>
                            <LabelForm>Hasta:</LabelForm>                        
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' margen_arriba={20}>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>                        
                        </ContainerCol>
                    </Row>         
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={10}>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' onClick={this.generarReporteVentas}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm' onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen15);